import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  const services = [
    { 
      title: 'Service Particulier', 
      link: '/services/service-particulier', 
      image: '/wp-content/uploads/2025/02/lawn-aeration-using-powerful-gasoline-powered-aera-2023-11-27-05-02-15-utc-scaled.jpg',
      description: 'La société Callgarden est spécialisée dans l\'entretien de jardin sur...',
      icon: '🏠'
    },
    { 
      title: 'Service entreprises', 
      link: '/services/service-entreprises', 
      image: '/wp-content/uploads/2025/02/jardins-d-entreprise.jpg',
      description: 'La société Callgarden est compétente pour l\'entretien de vos espaces...',
      icon: '🏢'
    },
    { 
      title: 'Nettoyage de terrasse', 
      link: '/nettoyage-terrasse-île-de-france', 
      image: '/wp-content/uploads/2025/02/cleaning-residential-driveway-2023-11-27-05-18-11-utc-1-scaled.jpg',
      description: 'Service professionnel de nettoyage de terrasse...',
      icon: '🧹'
    },
    { 
      title: 'Élagage d\'arbres', 
      link: '/elagage-arbre-île-de-france', 
      image: '/wp-content/uploads/2025/02/removing-trees-from-electrical-wires-on-the-street-2025-02-22-07-04-57-utc-scaled.jpg',
      description: 'Élagage professionnel et sécurisé de vos arbres...',
      icon: '🌳'
    },
    { 
      title: 'La Tonte', 
      link: '/services/la-tonte', 
      image: '/wp-content/uploads/2025/02/mowing-the-grass-2023-11-27-05-26-17-utc-scaled.jpg',
      description: 'Tonte régulière de votre pelouse pour un gazon impeccable...',
      icon: '✂️'
    },
    { 
      title: 'Taillage de haie', 
      link: '/tailler-haies-evry-courcouronnes', 
      image: '/wp-content/uploads/2025/02/comment_tailler_haie-scaled-1.jpg',
      description: 'Taille de haie professionnelle pour un rendu net et esthétique...',
      icon: '🌿'
    },
    { 
      title: 'Aménagement paysager', 
      link: '/services/amenagement-paysager', 
      image: '/paysager/paysager.webp',
      description: 'L\'aménagement paysager transforme votre espace extérieur en un véritable havre de paix...',
      icon: '🌳'
    },
    { 
      title: 'Crédit d\'impôt jardin', 
      link: '/services/credit-dimpot-jardin', 
      image: '/wp-content/uploads/2025/04/reduction-impots-label-vitre-nettoyage-vitrerie-lille.png',
      description: 'Crédit d\'impôt jardin : comment bénéficier de cet avantage fiscal...',
      icon: '💰'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">CallGarden Services</div>
          <h1 className="page-title">Nos Services</h1>
          <p className="section-description">
            Chez Callgarden on vous accompagne dans l'entretien de votre jardin, que ce soit pour la tonte, la taille ou le nettoyage de la terrasse. Découvrez tous les services que nos jardiniers peuvent vous offrir !
          </p>
        </div>

        <div className="cards-grid" style={{marginTop: 'var(--spacing-xl)'}}>
          {services.map((service, index) => (
            <div key={index} className="modern-card">
              <div className="card-icon" style={{fontSize: '2.5rem'}}>{service.icon}</div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-description">{service.description}</p>
              <Link to={service.link} className="card-link">
                En savoir plus
                <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor">
                  <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
